module.exports = __webpack_public_path__ + "static/img/FAQ_page top img_mobile.11b641d5.jpg";